import React from 'react';
import { apiConstants } from '../_constants';
import { millisecondsToHHMMSS } from '../_services/misc.service';

export const ScoreBoard = ({ scoreBoard }) => {
  return (
    <div className='boardistcontainer  '>
      <div className='scorehead mt-4'>LeaderBoard</div>
      <div className='listview  p-3 ps-0'>
        {scoreBoard.map((item, index) => (
          <div className='winneritem' key={index}>
            <div className='d-flex justify-content-center align-items-center gap-10'>
              <div className='indexcount'>{index + 1}</div>
              <div className='userData'>
                <img
                  src={
                    item?.profile_image
                      ? apiConstants.imgUrl + item?.profile_image
                      : '/img/user_dummy.png'
                  }
                  className='userimg'
                />
                <div className='userotherdata'>
                  <div className='username'>{item?.first_name}</div>
                  <div className='userscore'>
                    <img src='/img/question_icon.png' className='desc_icon' />{' '}
                    {parseInt(item?.attended_questions)} attended, {parseInt(item?.total_score)}{' '}
                    correct
                  </div>
                  <div className='userscore'>
                    {millisecondsToHHMMSS(parseInt(item?.time_taken))}
                  </div>
                </div>
              </div>
            </div>

            <img src='/img/trophy.png' className='trophyicon' />
          </div>
        ))}
      </div>
    </div>
  );
};
